export default __webpack_public_path__ + "static/media/07_understanding_results.24165713.png";